
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

export type BooleanProps = {
    label: string,
    value: boolean, 
    onChange: (newValue: boolean) => void, 
    readOnly: boolean, 
    [rest: string]: any,
}

export default function YesNo({ label, value, onChange, validate, readOnly, ...rest }: BooleanProps) {

    return (
        <>
            <label>{label}<br/>
                <ToggleButtonGroup color="standard" sx={{ borderRadius: "10px", border: "1px dotted black", height: "28px", backgroundColor: readOnly ? "#F0F0F0" : "#E8E8DF" }}
                    value={value ? "Yes" : "No"}
                    exclusive
                    onChange={(event, newValue) => {onChange(newValue === "Yes")}}
                    aria-label="Yes or No"
                >
                    <ToggleButton value="Yes">Yes</ToggleButton>
                    <ToggleButton value="No">No</ToggleButton>
                </ToggleButtonGroup>
            </label>
        </>
    )
}
